import { useEffect, useState } from 'react';

export const useAnimatedView = (blockRef) => {
  const [isVisible, setIsVisible] = useState(false);

  const isInViewport = (element) => {
    if (!element) return false; // Ensure the element exists
    const rect = element.getBoundingClientRect();
    return (
      rect.top < (window.innerHeight || document.documentElement.clientHeight) && // Top is above viewport bottom
      rect.bottom > 0 && // Bottom is below viewport top
      rect.left < (window.innerWidth || document.documentElement.clientWidth) && // Left is within viewport right
      rect.right > 0 // Right is within viewport left
    );
  };

  useEffect(() => {
    const handleScroll = () => {
      if (blockRef?.current && isInViewport(blockRef.current)) {
        setIsVisible(true);
      }
    };

    // Throttle scroll handling for performance
    const throttledHandleScroll = throttle(handleScroll, 100);

    window.addEventListener('scroll', throttledHandleScroll);
    handleScroll(); // Trigger on mount

    return () => {
      window.removeEventListener('scroll', throttledHandleScroll);
    };
  }, [blockRef]);

  return { isVisible };
};

// Utility to throttle scroll events
const throttle = (func, limit) => {
  let lastFunc;
  let lastRan;
  return function () {
    const context = this;
    const args = arguments;
    if (!lastRan) {
      func.apply(context, args);
      lastRan = Date.now();
    } else {
      clearTimeout(lastFunc);
      lastFunc = setTimeout(function () {
        if (Date.now() - lastRan >= limit) {
          func.apply(context, args);
          lastRan = Date.now();
        }
      }, limit - (Date.now() - lastRan));
    }
  };
};
